import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { lassoForm, Text, TextArea, validator } from '@bd/bdui-forms';
import { Redirect } from '@bd/bdcore-named-routes';
import { css, cx } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { colors } from '../styles';


const styles = css`
  label {
    font-weight: bold;
    font-size: 14px;
    margin: 0 0 2px 0;
    color: ${colors.color5Light};
    .required {
      color: #dc3545;
    }
    @media (min-width: 991px) {
      font-size: 15px;
    }
  }
  .form-row {
    margin: 0 0 30px 0;
    .col {
      padding: 0 30px 0 0;
      @media (max-width: 991px) {
        padding: 0;
      }
    }
    @media (max-width: 991px) {
      margin: 0 0 15px 0;
    }
  }
  input, textarea {
    border-radius: 0;
    border-color: #E7E7E7;
    color: ${colors.color5Light};
  }
  input {
    padding: 5px;
    @media (min-width: 992px) {
      padding: 5 15px;
    }
  }
  textarea {
    padding: 10px 5px;
    @media (min-width: 992px) {
      padding: 15px;
    }
  }
  .ContactUsModal_ty{
    h4, p {
      color: ${colors.color5Light};
    }
  }
`;

function validate(values) {
  const response = {
    firstName: null,
    lastName: null,
    email: null,
  };

  if (!values.firstName) {
    response.firstName = {
      error: 'First Name is required',
    };
  }

  if (!values.lastName) {
    response.lastName = {
      error: 'Last Name is required',
    };
  }

  if (!values.email) {
    response.email = {
      error: 'Email is required',
    };
  } else if (!validator.isEmail(values.email)) {
    response.email = {
      error: 'Email must be valid',
    };
  }

  return response;
}

class ContactModalForm extends React.Component {
  constructor(props) {
    super(props);

    const { formApi } = props;

    formApi.setValue('formName', this.props.formName);
    formApi.setValue('formLabel', this.props.formLabel);

    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.success && !this.props.success) {
      this.props.onSuccess();
    }
  }

  render() {
    const { className, formApi, success, noRedirect } = this.props;
    function getError(field) {
      return get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`);
    }

    function getErrorClass(field) {
      if (get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`)) {
        return 'is-invalid';
      }

      return null;
    }

    if (success) {
      return (
        <div className={styles}>
          {
            !noRedirect &&
            <Redirect
              name="contact-us-thank-you"
            />
          }
          {
            noRedirect &&
            <div className="ContactUsModal_ty">
              <h4>Thank You!</h4>
              <p>
                Thanks for contacting us.{' '}
                We have recieved your message and will respond as soon as possible.
              </p>
            </div>
          }
        </div>
      );
    }

    return (
      <div className={cx(styles, className)}>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CMF_firstName">First Name <span className="required">*</span></label>
            <Text
              id="CMF_firstName"
              field="firstName"
              name="firstName"
              className={`form-control ${getErrorClass('firstName')}`}
            />
            <div className="invalid-feedback">
              {getError('firstName')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CMF_lastName">Last Name <span className="required">*</span></label>
            <Text
              id="CMF_lastName"
              field="lastName"
              name="lastName"
              className={`form-control ${getErrorClass('lastName')}`}
            />
            <div className="invalid-feedback">
              {getError('lastName')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CMF_email">Email <span className="required">*</span></label>
            <Text
              id="CMF_email"
              field="email"
              name="email"
              className={`form-control ${getErrorClass('email')}`}
            />
            <div className="invalid-feedback">
              {getError('email')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="CMF_comments">Comments</label>
            <TextArea
              id="CMF_comments"
              field="comments"
              name="comments"
              className="form-control"
              placeholder="How can we help you?"
              rows="4"
            />
          </div>
        </div>
        <button type="submit" className="Btn">Send</button>
      </div>
    );
  }
}

ContactModalForm.propTypes = {
  className: PropTypes.string,
  formApi: PropTypes.object.isRequired,
  formName: PropTypes.string,
  formLabel: PropTypes.string,
  success: PropTypes.bool,
  onSuccess: PropTypes.func,
  noRedirect: PropTypes.bool,
};

ContactModalForm.defaultProps = {
  className: undefined,
  formName: 'contactUsModal',
  formLabel: 'Contact Us Popup',
  success: undefined,
  onSuccess: () => {},
  noRedirect: false,
};

export default lassoForm({
  validate,
})(
  withData(
    {
      communities: true,
      areas: true,
    },
  )(ContactModalForm),
);



// WEBPACK FOOTER //
// ./src/components/ContactModalForm.js